module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-app', [_c('v-alert', {
    attrs: {
      "elevation": "5",
      "title": "שגיאה",
      "value": true,
      "type": "error",
      "icon": "",
      "dismissible": ""
    }
  }, [_vm._v("\n      אירעה שגיאה, ניתן לנסות לרענן את העמוד.\n      "), _c('br'), _vm._v("\n      במידה והשגיאה נמשכת אנא צרו איתנו קשר.\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aee865d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/ErrorMessage.vue
// module id = 582
// module chunks = 9